<template>
    <main>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-justify-between">
                <div class="info-container tw-flex tw-justify-center tw-flex-col">
                    <div class="tw-flex lg:tw-flex-col">
                        <img src="~@/assets/img/evo-box.png">
                        <h1 class="tw-text-white">L’OFFRE QUI PEUT FAIRE<br>PLAISIR À VOTRE TIRELIRE</h1>
                    </div>
                    <h2 class="tw-text-white">JUSQU’À <span>7% DE RÉDUCTION</span> AVEC EVO <sup>(1)</sup></h2>
                    <div class="tw-flex tw-items-center">
                        <img src="~@/assets/img/icons/light.svg">
                        <img src="~@/assets/img/icons/gas.svg">
                        <h3 class="tw-text-white">Pour toute souscription aux 2 énergies :<br><span>-10%</span> sur l’abonnement électricité <sup>(2)</sup></h3>
                    </div>
                </div>
                <div class="form-container tw-relative">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>
        <section class="grid tw-py-10 lg:tw-py-12">
            <div class="tw-container">
                <div class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-12 lg:tw-flex-row lg:tw-items-start lg:tw-w-3/4 lg:tw-mx-auto">
                    <div class="tw-flex tw-flex-col tw-justify-start tw-items-center">
                        <img src="~@/assets/img/icons/rss.svg">
                        <p class="tw-text-center tw-mt-4">Offre 100% web</p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-justify-start tw-items-center">
                        <img src="~@/assets/img/icons/7percent.svg">
                        <p class="tw-text-center tw-mt-4">Jusqu’à 7% de réduction<br>sur le prix de votre énergie HT(1)<br>indexé sur les tarifs réglementés</p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-justify-start tw-items-center">
                        <img src="~@/assets/img/icons/free.svg">
                        <p class="tw-text-center tw-mt-4">Offre sans engagement</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="image tw-pb-10 lg:tw-pb-12">
            <div class="tw-container tw-flex tw-items-center tw-justify-center">
                <div><img src="~@/assets/img/award.png"></div>
            </div>
        </section>
        <section class="info">
            <div class="tw-container">
                <p>(1) Pendant 1 an, bénéficiez de 7% de réduction sur le prix du kWh HT de gaz et de 3% sur le prix du kWh HT d'électricité par rapport à ceux des tarifs réglementés HT de ces énergies en vigueur pendant la période de consommation. Il s’agit d’une offre d’énergie à prix variable. Les prix de l’offre Evo sont indexés sur les tarifs réglementés.  Si les prix des tarifs réglementés baissent alors vos prix baissent. À l’inverse, s’ils augmentent, vos prix augmentent.</p>
                <p>(2) En choisissant Eni comme fournisseur pour votre gaz et votre électricité, vous bénéficiez d’un Service Client unique, vous recevez vos factures sous un pli unique et toutes les informations concernant vos deux énergies seront disponibles sur la même interface en ligne. Pour Eni, la gestion administrative est facilitée, il est normal que vous en profitiez. C’est pourquoi Eni baisse de 10% le prix HT de votre abonnement d'électricité.</p>
                <p>Cette remise de 10% applicable sur le montant HT de l’abonnement électricité est valable pendant la première période contractuelle pour toute souscription aux deux énergies (électricité et gaz) auprès d’Eni sur un même lieu de consommation. La remise est accordée exclusivement sous condition d’être toujours en vigueur à la date de souscription de la seconde énergie. Elle cessera d’être applicable en cas de résiliation ou renonciation à l’une ou l’autre de ces énergies.</p>
                <p>(3) Eni Gas & Power France (Eni), traite les données personnelles recueillies en vue de proposer une opération de prospection commerciale. Les données collectées conditionnent sa gestion et sa correcte exécution. Elles sont conservées pendant 3 ans et sont destinées aux service commercial, service marketing et prestataires commerciaux d’Eni Gas & Power France (les sociétés Webhelp SAS et Business Support Services dont une partie de l’activité est gérée en dehors de l’Union européenne). Pour plus d’informations sur la gestion de vos données et sur vos droits, consultez la politique de confidentialité d’Eni à l’adresse suivante : https://fr.eni.com/particuliers/politique-de-confidentialite</p>
                <p>(4) En validant le formulaire, vous acceptez que vos coordonnées téléphoniques soient transmises à nos partenaires. Ce consentement prévaut sur une éventuelle inscription à la liste d’opposition Bloctel. Vous avez la possibilité de vous inscrire sur la liste Bloctel à tout moment.</p>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
